import Vue from 'vue'

Vue.filter('dateFormat', (value, format = 'YYYY.MM.DD') => {
  return Vue.prototype.$moment(value || new Date(), 'YYYY-MM-DD hh:mm:ss').format(format)
})

Vue.filter('highlight', (word, find) => {
  const regex = new RegExp(find, 'g')
  if (find) {
    if (word) {
      return word.replace(regex, "<span class='highlight'>" + find + '</span>')
    } else {
      return word
    }
  } else {
    return word
  }
})
